import React, { PropsWithChildren } from 'react';

import Sidebar, { SidebarTitleButton } from '@components/sidebar/Sidebar';

interface Props extends PropsWithChildren {
  sidebarFixed?: boolean;
  sidebarActive: number;
  sidebarButtons: JSX.Element[];
  sidebarButtonDivider?: JSX.Element;
  sidebarActiveItemMobileView: JSX.Element;
  sidebarOnClick: (index: number) => void;
  sidebarTitle: string;
  sidebarTitleButtons?: (SidebarTitleButton | JSX.Element)[];
  sidebarOnSearch?: (val: string) => void;
  sidebarSearchPlaceholder?: string;
  viewStyles?: React.CSSProperties;
}

const Page: React.FC<Props> = ({
  sidebarFixed,
  sidebarActive,
  sidebarButtons,
  sidebarButtonDivider,
  sidebarActiveItemMobileView,
  sidebarOnClick,
  sidebarOnSearch,
  sidebarTitle,
  sidebarTitleButtons,
  sidebarSearchPlaceholder,
  viewStyles,
  children,
}) => {
  const CSSBlock = 'page';

  return (
    <div className={`${CSSBlock} ${sidebarFixed ? `${CSSBlock}--sidebar-fixed` : ''}`}>
      <Sidebar
        fixed={sidebarFixed}
        customButtons={sidebarButtons}
        customButtonsDivider={sidebarButtonDivider}
        activeItemMobileView={sidebarActiveItemMobileView}
        active={sidebarActive}
        title={sidebarTitle}
        titleButtons={sidebarTitleButtons}
        onClick={sidebarOnClick}
        onSearch={sidebarOnSearch}
        searchPlaceholder={sidebarSearchPlaceholder}
      />
      <div className={`${CSSBlock}__view`} style={viewStyles}>
        {children}
      </div>
    </div>
  );
};

export default Page;
